export const initComplexLayout = ( slider ) => {
	const complexLayout = slider.querySelector( 'li.complex-layout' );

	if ( !complexLayout || !complexLayout.querySelector( 'svg' ) )
	{
		return;
	}

	const guidBuilding = complexLayout.dataset.guidBuilding;
	const guidSection = complexLayout.dataset.guidSection;

	if ( !guidBuilding )
	{
		return;
	}

	if ( guidSection && complexLayout.querySelector( `#SEC-${guidSection}` ) )
	{
		complexLayout.querySelector( `#SEC-${guidSection}` ).dataset.active = 'yes';
	}
	else
	{
		complexLayout.querySelector( `#BLD-${guidBuilding}` ).dataset.active = 'yes';
	}

	complexLayout.classList.add( 'loaded' );
};